export var NoteTypeEnum;
(function (NoteTypeEnum) {
    NoteTypeEnum["GROUP"] = "GROUP";
    NoteTypeEnum["PLAIN_TEXT"] = "PLAIN_TEXT";
    NoteTypeEnum["TOOLTIP"] = "TOOLTIP";
    NoteTypeEnum["DAMAGE"] = "DAMAGE";
    NoteTypeEnum["DISADVANTAGE_ICON"] = "DISADVANTAGE_ICON";
    NoteTypeEnum["DISTANCE"] = "DISTANCE";
    NoteTypeEnum["AOE_ICON"] = "AOE_ICON";
})(NoteTypeEnum || (NoteTypeEnum = {}));
export var DisplayIntentionEnum;
(function (DisplayIntentionEnum) {
    DisplayIntentionEnum["SCALED"] = "scaled";
    DisplayIntentionEnum["POSITIVE"] = "positive";
    DisplayIntentionEnum["NEGATIVE"] = "negative";
})(DisplayIntentionEnum || (DisplayIntentionEnum = {}));
